/**
 * Formata a data para exibir "Hoje", "Ontem" ou a data completa
 */
export const formatDayLabel = (dateString: string): string => {
  if (!dateString) return '';
  
  const messageDate = new Date(dateString);
  const today = new Date();
  
  // Zerar as horas para comparar apenas as datas (usando UTC)
  const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const messageDateUTC = Date.UTC(messageDate.getUTCFullYear(), messageDate.getUTCMonth(), messageDate.getUTCDate());
  
  const diffTime = todayUTC - messageDateUTC;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) {
    return 'Hoje';
  } else if (diffDays === 1) {
    return 'Ontem';
  } else {
    // Formato DD/MM/YYYY usando UTC
    const day = String(messageDate.getUTCDate()).padStart(2, '0');
    const month = String(messageDate.getUTCMonth() + 1).padStart(2, '0');
    const year = messageDate.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }
};

/**
 * Formata a hora no formato HH:mm
 */
export const formatHourLabel = (dateString: string): string => {
  if (!dateString) return '';
  
  // Como o timestamp já foi ajustado para o horário local do Brasil
  // ao ser gravado (via getBrazilTimestamp), precisamos extrair 
  // a hora diretamente da string UTC sem aplicar conversão de timezone
  const date = new Date(dateString);
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  
  return `${hours}:${minutes}`;
};

/**
 * Formata a data da última mensagem de forma compacta para a lista
 */
export const formatLastMessageDate = (dateString: string): string => {
  if (!dateString) return '';
  
  const messageDate = new Date(dateString);
  const today = new Date();
  
  // Zerar as horas para comparar apenas as datas (usando UTC)
  const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const messageDateUTC = Date.UTC(messageDate.getUTCFullYear(), messageDate.getUTCMonth(), messageDate.getUTCDate());
  
  const diffTime = todayUTC - messageDateUTC;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) {
    // Hoje: mostrar apenas hora
    return formatHourLabel(dateString);
  } else if (diffDays === 1) {
    // Ontem
    return 'Ontem';
  } else if (diffDays < 7) {
    // Última semana: mostrar dia da semana
    const weekdays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
    return weekdays[messageDate.getUTCDay()];
  } else {
    // Mais antigo: mostrar data
    const day = String(messageDate.getUTCDate()).padStart(2, '0');
    const month = String(messageDate.getUTCMonth() + 1).padStart(2, '0');
    return `${day}/${month}`;
  }
};
